<template>
  <div class="componentSty">
    <m-title :titlelist="listitem"></m-title>
    <div class="componentSty_content">
      <div class="componentSty_content_title">
        <span class="fonints">派车状态</span>
        <el-dropdown trigger="click" placement="bottom-start">
          <span style="color: #409eff; fontweight: 600;cursor: pointer;">{{ checkitem1 }}</span>
          <el-dropdown-menu slot="dropdown" style="width: 100px;">
            <div class="menu_box">
              <el-dropdown-item
                v-for="item in regionList"
                :key="item.id"
                @click.native="dropdownItem(item, 'status')"
                >{{ item.name }}</el-dropdown-item
              >
            </div>
          </el-dropdown-menu>
        </el-dropdown>
        <span class="fonints">支付状态</span>
        <el-dropdown trigger="click" placement="bottom-start">
          <span style="color: #409eff; fontweight: 600;cursor: pointer;">{{ checkitem2 }}</span>
          <el-dropdown-menu slot="dropdown" style="width: 100px">
            <div class="menu_box">
              <el-dropdown-item
                v-for="item in payStatus"
                :key="item.id"
                @click.native="dropdownItem(item, 'type')"
                >{{ item.name }}</el-dropdown-item
              >
            </div>
          </el-dropdown-menu>
        </el-dropdown>
        <span class="fonints">派车时间</span>
        <el-date-picker
          v-model="datamsg1"
          @change="dataChange($event, ['startTime', 'endTime'])"
          type="datetimerange"
          range-separator="至"
          value-format="yyyy-MM-dd HH:mm:ss"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          :default-time="['00:00:00', '00:00:00']"
        >
        </el-date-picker>
        <span class="fonints">支付时间</span>
        <el-date-picker
          v-model="datamsg2"
          @change="dataChange($event, ['icstartTime', 'icendTime'])"
          type="datetimerange"
          range-separator="至"
          value-format="yyyy-MM-dd HH:mm:ss"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          :default-time="['00:00:00', '00:00:00']"
        >
        </el-date-picker>
      </div>
      <div class="componentSty_content_title">
        <span class="fonints">退款时间</span>
        <el-date-picker
          v-model="datamsg3"
          @change="dataChange($event, ['restartTime', 'reendTime'])"
          type="datetimerange"
          range-separator="至"
          value-format="yyyy-MM-dd HH:mm:ss"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          :default-time="['00:00:00', '00:00:00']"
        >
        </el-date-picker>
        <button class="buttons" @click="querylist">查询</button>
        <button
          class="buttons"
          @click="cleartiaojian"
          style="background: #ff5926"
        >
          清空
        </button>
         <button class="buttons" style="background: #0057be" @click="printList">
          导出Excel
        </button>
      </div>
      <div class="componentSty_content_table" style="top: 90px">
        <el-table  height="80%" :data="arrlist.data" style="width: 100%; height: 80%">
             <el-table-column
            label="序号"
            type="index"
            width="50px"
          ></el-table-column>
          <el-table-column prop="pno" label="计划单号"> </el-table-column>
          <el-table-column prop="plate" label="车牌号"> </el-table-column>
          <el-table-column prop="fleetname" label="代理简称"> </el-table-column>
          <el-table-column prop="custmername" label="流向"> </el-table-column>
          <!-- <el-table-column prop="paichename" label="派车账号">
          </el-table-column> -->
          <el-table-column label="派车时间">
            <template v-slot="res">
              <span>{{ mydateFormat(res.row.gmtCreate, "时分秒") }}</span>
            </template>
          </el-table-column>
          <el-table-column label="付款时间">
            <template v-slot="res">
              <span>{{ mydateFormat(res.row.icstartTime, "时分秒") }}</span>
            </template>
          </el-table-column>
          <el-table-column label="退款时间">
            <template v-slot="res">
              <span>{{ mydateFormat(res.row.restartTime, "时分秒") }}</span>
            </template>
          </el-table-column>
		  <el-table-column label="派车状态">
		    <template v-slot="res">
		      <span
		        style="color: #ef6b60"
		        class="el_spanfontstyle"
		        v-if="res.row.status == 0"
		        >进行中</span
		      >
		      <span
		        style="color: #448aff"
		        class="el_spanfontstyle"
		        v-if="res.row.status == 1"
		        >已完成</span
		      >
		      <span
		        style="color: #448aff"
		        class="el_spanfontstyle"
		        v-if="res.row.status == 2"
		        >已取消</span
		      >
		      <span
		        style="color: #448aff"
		        class="el_spanfontstyle"
		        v-if="res.row.status == 3"
		        >未知</span
		      >
		    </template>
		  </el-table-column>
		  
          <el-table-column label="状态">
            <template v-slot="res">
              <span
                style="color: #ef6b60"
                class="el_spanfontstyle"
                v-if="res.row.icbcstatus == '0'"
                >未支付</span
              >
              <span
                style="color: #448aff"
                class="el_spanfontstyle"
                v-if="res.row.icbcstatus == '1'"
                >已支付</span
              >
              <span
                style="color: #448aff"
                class="el_spanfontstyle"
                v-if="res.row.icbcstatus == '2'"
                >已退款</span
              >
            </template>
          </el-table-column>
        </el-table>
		<div class="msgstatistics">
		  <span>总派车数:{{arrlist.count }}&emsp; &emsp; &emsp; &emsp; </span>
		  <span>总支付笔数:{{arrlist.countorder}}&emsp; &emsp; &emsp; &emsp;</span>
		  <span>总退款笔数:{{arrlist.countreturn}}&emsp; &emsp; &emsp; &emsp;</span>
		  <span>未支付笔数:{{arrlist.nopay}}</span>
		</div>
        <div class="paginations" v-show="arrlist.data&&arrlist.data.length">
          <el-pagination
            :page-size="selectitem.limit"
           layout="total,prev, pager,next, jumper"
            :total="arrlist.count - 0"
             :current-page="selectitem.page"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mTitle from "@/components/mTitle";
import mSelect from "@/components/mSelect";
import mSwitch from "@/components/mSwitch.vue";
import {  printExcel } from "@/plugins/other.js";
export default {
  data() {
    return {
      listitem: [{ name: "财务统计" }, { name: "派车对账" }],
      checkitem1: "全部",
      checkitem2: "全部",
      regionList: [
        { id: null, name: "全部" },
        { id: 0, name: "进行中" },
        { id: 1, name: "已完成" },
        { id: 2, name: "已取消" },
      ],
      payStatus: [
        { id: null, name: "全部" },
        { id: 0, name: "无支付" },
        { id: 1, name: "已支付" },
        { id: 2, name: "已退款" },
      ],
      datamsg1: [],
      datamsg2: [],
      datamsg3: [],
      arrlist: {},
      selectitem: {
        page: 1, //当前页码
        limit: 20, //每页显示条数
        pno: null, //计划编号
        startTime: null, //开始时间
        endTime: null, //结束时间
        icstartTime: null, //支付开始时间
        icendTime: null, //支付结束时间
        restartTime: null, //退款开始时间
        reendTime: null, //退款结束时间
        status: null,
        type: null,
      },
    };
  },
  components: {
    mTitle,
    mSelect,
    mSwitch,
  },
  methods: {
    async getjobdetails() {
      const { data } = await this.$http(
        "api1",
        "/csvanalysis/csv/truckanalysis",
        "get",
        this.selectitem
      );
      if (data.code != 0) return this.$message.error(data.msg);
      this.arrlist = data;
    },
    querylist() {
      this.timeout = setTimeout(() => {
        this.selectitem.page = 1;
        this.getjobdetails();
      }, 300);
    },
    printList(){
      printExcel.call(this,"/csvanalysis/csv/truckanalysisexsx","派车对账",this.selectitem,"get");
    },
    dataChange(val, arr) {
      val=val||[];
      this.selectitem[arr[0]] = val[0];
      this.selectitem[arr[1]] = val[1];
    },
    dropdownItem(item, val) {
      switch (val) {
        case "status":
          this.checkitem1 = item.name;
          this.selectitem[val] = item.id;
          break;
        case "type":
          this.checkitem2 = item.name;
          this.selectitem[val] = item.id;
          break;
      }
    },
    cleartiaojian() {
      this.timeout = setTimeout(() => {
        this.datamsg = [];
        this.checkitem1 = "全部";
        this.checkitem2 = "全部";
        this.checkitem3 = "全部";
        this.datamsg1=[];
        this.datamsg2=[];
        this.datamsg3=[];
        this.selectitem = {
          page: 1, //当前页码
          limit: 20, //每页显示条数
          pno: null, //计划编号
          startTime: null, //开始时间
          endTime: null, //结束时间
          icstartTime: null, //支付开始时间
          icendTime: null, //支付结束时间
          restartTime: null, //退款开始时间
          reendTime: null, //退款结束时间
          status: null,
          type: null,
        };
      }, 300);
    },
    handleCurrentChange(index) {
      if (this.arrlist.totalCount < this.selectitem.limit) return;
      this.selectitem.page = index;
      this.getjobdetails();
    },
  },
};
</script>
<style lang="scss" src="@/assets/components.scss" scoped></style>